module.exports = __webpack_public_path__ + "static/media/mailIcon.357ea245.svg";